<template>
  <div id="app" class="container is-fluid" >
    <div class="columns" v-if="authenticated && everythingLoaded">
      <div class="column leftnav is-fullheight">
        <left-menu v-on:logout="logout"></left-menu>
      </div>
      <div class="column main">
        <div class="wrapper">
          <router-view/>
        </div>

      </div>
    </div>
    <b-modal v-else :active="!authenticated">
      <login></login>
    </b-modal>
    <div id="notifications">
      <b-notification v-for="(notification,t_index) in messages" v-bind:key="t_index" :type="notification.type"
                      :has-icon="notification.hasIcon" v-on:close="removeMessage(t_index)">
        {{notification.text}}
      </b-notification>
    </div>
    <b-loading :active.sync="isLoading"></b-loading>

  </div>
</template>

<script>
import LeftMenu from './components/LeftMenu'
import login from './components/partials/modals/Login'

export default {
  name: 'App',
  data: function () {
    return {
      initialized: false
    }
  },
  mounted () {},
  components: {
    LeftMenu,
    login
  },
  computed: {
    mainData: function () {
      return this.$store.state.data.Main || null
    },
    everythingLoaded: function () {
      return (this.mainData && this.authenticated)
    },
    isLoading: function () {
      return (this.$store.state.axiosInstances > 0)
    },
    messages: function () {
      return this.$store.state.messages
    },
    authenticated: function () {
      return this.$store.state.authenticated
    }
  },
  methods: {
    removeMessage: function (index) {
      console.log('Removing one thing with index ' + index)
      this.$store.commit('removeMessage', index)
    },
    logout: function () {
      this.$store.commit('authenticated', false)
      localStorage.removeItem('accessToken')
    }
  }
}
</script>
